import i18n from 'scoreboard/components/i18n'
import unwrapModel from 'scoreboard/components/unwrap-model'

function totalOption(dataset) {
	dataset = unwrapModel(dataset)
	var totalLabel = i18n.get('datasets.total.tracked', dataset.tracked)
	return {
		// this is awkward because it's not how we store stuff in the DB
		// but it's going to work out a lot easier for the UI layer
		id: -1 * dataset.rootDatasetId,
		label: totalLabel
	}
}

export default totalOption

totalOption.__filename__ = 'datasets/total-option.js'
